import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { WorkflowForm } from 'app/models/workflow-form';
import { WorkflowTemplateService } from 'app/services/workflow-template.service';
import { WorkflowWizardService } from 'app/services/workflow-wizard.service';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { StepCompletionSelectorComponent } from '../step-completion-selector/step-completion-selector.component';

@Component({
  selector: 'app-delete-step',
  templateUrl: './delete-step.component.html',
  styleUrls: ['./delete-step.component.scss']
})
export class DeleteStepComponent implements OnInit {

  currentStepFormGroup: FormGroup = null;
  numberOfBranches: number = 0;
  @Output() stepDeleted: EventEmitter<any> = new EventEmitter<any>();
  @Output() modalClosed: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('deleteConfirmationModal', {static: false}) deleteConfirmationModal: ModalDirective;
  @ViewChild('formsInUseModal', {static: false}) formsInUseModal: ModalDirective;
  @ViewChild('stepCompletionSelector', {static: false}) stepCompletionSelector: StepCompletionSelectorComponent;

  formsDictUsedIn: {[key: string]: string[]} = {};

  constructor(private workfowTemplateService: WorkflowTemplateService, private workflowWizardService: WorkflowWizardService) { }

  ngOnInit(): void {
  }

  show(stepFormGroup: FormGroup) {
    this.currentStepFormGroup = stepFormGroup;
    this.numberOfBranches = 0;
    (<FormArray>this.currentStepFormGroup.get('step_completions')).controls.forEach((stepCompletionFormGroup) => {
      if (stepCompletionFormGroup.value && stepCompletionFormGroup.value.next_step && stepCompletionFormGroup.value.next_step.name) {
        this.numberOfBranches++;
      }
    });
    this.deleteConfirmationModal.show();
  }

  canDeleteAndKeepBranch(branchIndex: number) : boolean {
    this.formsDictUsedIn = {};

    (<WorkflowForm[]>this.currentStepFormGroup.get('step_completions.' + branchIndex + '.forms').value || []).forEach((f) => {
      if (!f.is_existing) {
        (<FormArray>this.currentStepFormGroup.get('step_completions.' + branchIndex + '.next_step.step_completions')).controls.forEach((childStepCompletion) => {
          let result = this.workflowWizardService.isFormUsedInWorkflow(f.name, <FormGroup>childStepCompletion);
          if (result) {
            this.formsDictUsedIn[f.name] = result;
          }  
        });
      }
    });

    return Object.keys(this.formsDictUsedIn).length == 0;
  }

  deleteStep(wholeBranch: boolean = false) {
    if (wholeBranch) {
      this.workfowTemplateService.deleteStep(this.currentStepFormGroup);
      this.stepDeleted.emit();
    } else {
      /** @todo check if materials are used in subsequent steps */
      if (this.numberOfBranches == 1) {
        let branchIndexToKeep: number = (<FormArray>this.currentStepFormGroup.get('step_completions')).controls.findIndex((stepCompletionFormGroup) => {
          return stepCompletionFormGroup.value && stepCompletionFormGroup.value.next_step && stepCompletionFormGroup.value.next_step.name;
        });
        if (this.canDeleteAndKeepBranch(branchIndexToKeep)) {
          this.workfowTemplateService.deleteStep(this.currentStepFormGroup, branchIndexToKeep);
          this.stepDeleted.emit();
        } else {
          this.formsInUseModal.show();
        }
      } else {
        // ask which branch to keep
        this.stepCompletionSelector.show(<FormArray>this.currentStepFormGroup.get('step_completions'), (selectedIndex) => {
          if (this.canDeleteAndKeepBranch(selectedIndex)) {
            this.workfowTemplateService.deleteStep(this.currentStepFormGroup, selectedIndex);
            this.stepDeleted.emit();  
          } else {
            this.formsInUseModal.show();
          }
        });
      }
    } 
  }

}
